module.exports = __webpack_public_path__ + "static/media/publish-videos-images-tabletPro-es.a5e6da3a.webp";